import { AnySelection, seriesSvgLine } from '@d3fc/d3fc-series';
import { deriveTime } from 'utils/components/TimeSeriesChart/TimeSeriesChartData';

export const boundaryLine = (value: number) =>
    seriesSvgLine()
        .crossValue(deriveTime)
        .mainValue(value)
        .decorate((s: AnySelection) => {
            s.classed('boundary-line', true);
        });

export const boundaryLines = (lowerBoundary: number, upperBoundary: number) => [
    boundaryLine(upperBoundary),
    boundaryLine(lowerBoundary),
];
